import React, { useState, useEffect } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Pagination } from '@mui/material';
import { url } from "../../urlConfig";
import { useLocation, useNavigate, useParams,Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import NavBar from "../../Components/NavBar";
import Cookies from "js-cookie";
import axios from "axios";

function AllPages({ initialData = {}, language }) {
  const [pois, setPois] = useState(initialData?.page?.data || []);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { location, slug } = useParams();
  const [catdata,setCatdata]=useState({})
  const [totalCount,setTotalCount]=useState(0)
  const isArabic = language === "ar";
  const lang = language;
  const navigate = useNavigate();
  const location2 = useLocation();
  const [nameLocation, setNameLocation] = useState({});
  const category = slug.match(/([a-f0-9]{24})/);
  let locationId = Cookies.get('locationId');
console.log("Todays Data...",initialData)
  function truncateText(text, wordLimit) {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  }

  useEffect(() => {
    const fetchPois = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://admin.hopdays.com/api/all_pois/${language}?skip=${(page-1)*12}&limit=12`, {
          params: {
            category: category?.[0],
            location: location,
            skip: (page - 1) * 10,
            limit: 10,
            SearchLocation:location.replace(/-/g, " ")
          },
        });

        const newPois = response.data.data;
        console.log({"newPois":response.data});
        setCatdata(response.data.category)
        setTotalCount(response.data.poisCount)
        setNameLocation(response.data.locationMatch)
        if(pois.length === 0) {
          setPois(newPois);
        } else {
          setPois((prevPois) => [...prevPois, ...newPois]);
        }
        // setPois([...pois,...newPois]);
        setTotalPages(Math.ceil(response.data.totalCount / 10)); // Update this line based on your backend response
      } catch (error) {
        console.error("Error fetching POIs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPois();
  }, [page]);

  const filteredPois = pois?.filter((pois) =>
    pois?.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );
console.log("filteredPois",location.replace(/-/g, " "))
  return (
    <div className={isArabic ? "text-right" : "text-left"}>
      <NavBar language={language || Cookies.get("lang")} />
      <div className={`lg:flex ${isArabic ? "flex-row-reverse lg:mr-40 max-sm:mr-4" : " max-sm:ml-4"}`}>
        <div className="lg:w-[25%]">
          <div className="lg:hidden flex justify-between">
            <div className="mt-5">
              <div className="relative">
                <SearchIcon className={`absolute ${isArabic ? "left-3" : "right-3"} top-1/2 transform -translate-y-1/2 text-gray-400`} />
                <input
                  type="text"
                  className={`outline-none rounded-lg py-1 ${isArabic ? "pr-3 pl-10" : "pl-3 pr-10"}`}
                  placeholder={isArabic ? "ابحث عن نقطة الاهتمام..." : "Search POI..."}
                  style={{ border: `1px solid black` }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-[200%]">
          <div className={`max-sm:hidden ${isArabic ? "flex-row-reverse" : ""}`}>
            <div>
            {(isArabic
  ? (catdata?.ar_subCategoryName || catdata?.ar_categoryName) && nameLocation?.ar_name
  : (catdata?.subCategoryName || catdata?.categoryName) && nameLocation?.name
) && (
  <h2 className="font-semibold text-[25px] capitalize mt-10 mb-5 max-sm:hidden">
    {isArabic 
      ? `${catdata?.ar_subCategoryName || catdata?.ar_categoryName} في ${nameLocation?.ar_name}`
      : `${catdata?.subCategoryName || catdata?.categoryName} in ${nameLocation?.name}`}
  </h2>
)}


              <div className="relative">
                <input
                  type="text"
                  className={`outline-none rounded-lg py-1 ${isArabic ? "pr-3 pl-10" : "pl-3 pr-10"}`}
                  placeholder={isArabic ? "ابحث عن نقطة الاهتمام..." : "Search POI..."}
                  style={{ border: `1px solid black` }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <div className="font-semibold text-[18px] mt-5 text-gray-400">
              {totalCount} {isArabic ? "نتائج" : "results"}
            </div>
          </div>
          <div className={`mt-5 font-semibold lg:hidden capitalize ${isArabic ? "text-right" : ""}`}> <h2 className="font-semibold text-[25px] mt-10 mb-5 ">
                {isArabic
                  ? `${catdata?.ar_subCategoryName || catdata?.ar_categoryName} في ${location.replace(/-/g, " ")}`
                  : `${catdata?.subCategoryName || catdata?.categoryName} in ${location.replace(/-/g, " ")}`}
              </h2></div>
          <div className={`lg:hidden font-semibold text-[18px] mt-1 text-gray-400 ${isArabic ? "text-right" : ""}`}>
            {totalCount} {isArabic ? "نتائج" : "results"}
          </div>

          <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 ${language == "ar" ? "flex-row-reverse" : ""}`}>
  {filteredPois?.length > 0 ? (
    filteredPois.map((i) => {
      const city2 = i?.cityData?.name?.toLocaleLowerCase().replace(/\s+/g, '-');
      const url = `${i.slug}-${i?.cityData?.name}-${i?.countryData?.name}-poi-${i._id}`;
      const url2 = url.toLowerCase().replace(/\s+/g, '-');
      const image = i.images[0];
      const isArabic = language == "ar";
      const navigateUrl = isArabic
        ? `/ar/place/${city2}/${url2}`
        : `/en/place/${city2}/${url2}`;
      const title = isArabic ? i.ar_title : i.title;
      const stateName = isArabic ? i?.stateData?.ar_name : i?.stateData?.name;
      const description = isArabic
        ? truncateText(i.ar_shortDescription, 130)
        : truncateText(i.shortDescription, 130);

      return (
        <Link
          key={i._id}
          to={navigateUrl}
          className="lg:w-[404px] max-sm:w-[90%] flex-none mb-5 cursor-pointer block"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <div>
            <img
              loading="lazy"
              src={image}
              alt={`${title} image`}
              className="lg:w-[404px] lg:h-[280px] max-sm:w-[90%] max-sm:h-[200px] rounded-md hover:shadow-xl"
            />
          </div>
          <div className="py-4">
            <p className="text-[20px] max-sm:text-[15px]">
              <b className="text-[22px] max-sm:text-[20px]">{title}, </b>
              {stateName}
            </p>
            <div
              className="lg:mt-5 max-sm:w-[90%] max-sm:mt-3 text-[17px] max-sm:text-[10px] lg:leading-5 max-sm:leading-3"
              dangerouslySetInnerHTML={{
                __html: `<span class="override-html">${truncateText(description, 30)}</span>`,
              }}
            />
          </div>
        </Link>
      );
    })
  ) : (
    <p>
      {language === "ar"
        ? "لا توجد نقاط اهتمام متاحة."
        : "No Points of Interest available."}
    </p>
  )}
</div>


          {/* Pagination UI */}
          <div className="flex justify-center my-8">
           {totalCount > filteredPois.length&& 
            <button className="bg-[#9747FF] py-1 text-white rounded-3xl px-3" onClick={()=>{
              setPage(page + 1);
            }}>Load More</button>
           }
          </div>
        </div>
      </div>
      <Footer language={language} />
    </div>
  );
}

export default AllPages;
